import React from 'react';
import ProfilePostList from './ProfilePostList';

function MyLimitedPaid() {
    return (
        <ProfilePostList endpoint={"my-limited-paid"}/>
    );
}

export default MyLimitedPaid;